module.exports = __webpack_public_path__ + "7230bd404c473946a148767c25138a6e.pdf";